import ReactDOM from 'react-dom/client';
// Global styles removed in favor of MUI CssBaseline
// Import fonts for typography
import '@fontsource/montserrat/700.css';  // App title branding
import '@fontsource/poppins/600.css';    // Headings
import '@fontsource/inter/400.css';      // Body text
import '@fontsource/roboto/300.css';     // Captions
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import App from './App';
import './i18n';
import {GoogleOAuthProvider} from "@react-oauth/google";
import { HelmetProvider } from 'react-helmet-async';
// Disable automatic scroll restoration to manage scroll position manually on route changes
if ('scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}

// Set CSS var --vh to handle mobile browser chrome (address bar) height quirks
function setVh() {
  document.documentElement.style.setProperty(
    '--vh',
    `${window.innerHeight * 0.01}px`
  );
}
window.addEventListener('resize', setVh);
setVh();

const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;
if (!clientId) {
    throw new Error("REACT_APP_GOOGLE_CLIENT_ID is not defined");
}

ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
).render(
  <GoogleOAuthProvider clientId={clientId}>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </GoogleOAuthProvider>
);

/*
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);
*/
